import React from 'react'
import Product from './Product'
import './home.css'
import Carousel from 'nuka-carousel';

function Home() {

    const settings = {
        autoplay: true,
        autoplayInterval: 5000,
        autoplayReverse: true,
        pauseOnHover: true,
        speed: 1500,
        wrapAround: true,
        defaultControlsConfig: {
            pagingDotsStyle: {
                padding: 5,
            }
        },
    }

    return (
        <div className='home'>
            <div className='home__container'>
                <Carousel {...settings} className='home__carousel'>
                    <img src='https://m.media-amazon.com/images/I/71H5hK4wUqL._SX3000_.jpg' 
                    className='home__banner'
                    alt='home banner'/>

                    <img src='https://m.media-amazon.com/images/I/61jovjd+f9L._SX3000_.jpg' 
                    className='home__banner'
                    alt='home banner'/>

                    <img src='https://m.media-amazon.com/images/I/61DUO0NqyyL._SX3000_.jpg' 
                    className='home__banner'
                    alt='home banner'/>

                    <img src='https://m.media-amazon.com/images/I/61TD5JLGhIL._SX3000_.jpg' 
                    className='home__banner'
                    alt='home banner'/>

                    <img src='https://m.media-amazon.com/images/I/71qid7QFWJL._SX3000_.jpg' 
                    className='home__banner'
                    alt='home banner'/>

                    <img src='https://m.media-amazon.com/images/I/610aFo74RdL._SX3000_.jpg' 
                    className='home__banner'
                    alt='home banner'/>
                </Carousel>
            </div>

            <div className='home__row'>
                <Product
                    img='https://m.media-amazon.com/images/I/71DkiXprgBS._AC_UL320_.jpg'
                    title='TOPOSH 11.6 inch 2 in 1 Laptop Tablet Computer with Touch Screen, Intel Celeron Quad Core N4120 8GB RAM...'
                    price= {29.99}
                    rating={4}
                    id='2218723568'
                />
                <Product
                    img='https://m.media-amazon.com/images/I/51fPuFND28L._AC_UL320_.jpg'
                    title='SAMSUNG Galaxy Tab S7 11-inch Android Tablet 128GB Wi-Fi Bluetooth S Pen Fast Charging USB-C Port, Mystic Black...'
                    price={499.00}
                    rating={5}
                    id='1756373637'
                />
            </div>

            <div className='home__row'>
                <Product 
                    img='https://m.media-amazon.com/images/I/61QHRATj+vL._AC_UY218_.jpg'
                    title='Donerton Smart Watch, Fitness Tracker for Android Phones, Fitness Tracker with Heart Rate and Sleep Monitor, Activity Tracker...'
                    price={37.99}
                    rating={4}
                    id='5272416829'
                />
                <Product
                    img='https://m.media-amazon.com/images/I/816z9yHvl4L._AC_UY218_.jpg'
                    title='SAMSUNG 55-Inch Class Neo QLED QN85A Series - 4K UHD Quantum HDR 24x Smart TV with Alexa Built-in...'
                    price={269.99}
                    rating={5}
                    id='2102830987'
                />
                <Product
                    img='https://m.media-amazon.com/images/I/81+0gf6ZqzL._AC_UL320_.jpg'
                    title="'PUMA Men's Enzo 2 Sneaker"
                    price={49.98}
                    rating={5}
                    id='2628238916'
                />
            </div>

            <div className='home__row'>
            <Product
                img='https://m.media-amazon.com/images/I/61gIsBN1vGL._AC_UL320_.jpg'
                title='HOTNIU Stretch Sofa Covers Printed Couch Cover Sofa Slipcovers for 3 Cushion Couches Elastic Universal Furniture...'
                price={33.99}
                rating={3}
                id='3218658972'
            />
            </div>
        </div>
    )
}

export default Home
